<template>
<div class="swaychat-row" @click="toggle" :class="{
    'swaychat-receipt-off': !tail && !showTail
    }"
    >
  <div class="swaychat-bubble-wrapper swaychat-bounceIn" :class="{
      'swaychat-operator': operator,
      'swaychat-visitor': !operator
      }">
    <div class="swaychat-bubble" :style="{
        'background-color': !operator ? getPrimaryBg : ''
        }">
      <div class="swaychat-loading-circle" v-if="media"></div>
      <p v-if="media" class="swaychat-bubble-media">
        <component :is="media.type+'Component'" :src="media.src"></component>
      </p>
      <p v-else v-html="parsed"></p>
    </div>
    <span class="swaychat-tail" :style="{
        'background-color': !operator ? getPrimaryBg : ''
        }"> </span>
  </div>
  <div class="swaychat-row swaychat-read-receipt" :class="{
      'swaychat-operator': operator,
      'swaychat-visitor': !operator
      }">
    <div v-if="name" class="swaychat-operators-avatar" :title="name" :class="{
        'swaychat-visitors-avatar': !operator
        }">
      <span :style="{
          'background-color': uidBg
          }">{{ initial }}</span>
      <img v-if="src" :src="makeAliasHost(src)" style="display:none" onload="this.style.display = ''" class="swaychat-bounceIn">
    </div>
    <span>{{ getLang.sent }} {{ sent }}</span>
  </div>
</div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import moment from 'moment'
import {
  uidToColor
} from '../../utils/helpers'
import secure from 'secure-filters'
import anchorme from 'anchorme'

import IframeComponent from '../media/IframeComponent.vue'
import ImageComponent from '../media/ImageComponent.vue'
import VideoComponent from '../media/VideoComponent.vue'
import AudioComponent from '../media/AudioComponent.vue'

export default {
  components: {
    IframeComponent,
    ImageComponent,
    VideoComponent,
    AudioComponent
  },
  props: [
    'operator',
    'tail',
    'message',
    'created_at',
    'from',
    'media',
    'msgKey',
    'read'
  ],
  data() {
    return {
      showTail: false
    }
  },
  computed: {
    parsed() {

      let m = this.message

      if (typeof m != 'string')
        return ''

      m = anchorme(m, {
        attributes: [{
          name: 'target',
          value: '_blank'
        }]
      })

      let links = m.match(/<a(.*?)<\/a>/g)
      if (links)
        for (let i = 0; i < links.length; i++)
          m = m.replace(links[i], 'urlVar' + i)

      m = secure.html(m)

      if (links)
        for (let i = 0; i < links.length; i++)
          m = m.replace('urlVar' + i, links[i])

      return m
    },
    uidBg() {
      return uidToColor(this.from)
    },
    src() {

      if (this.operator && this.getAgents)
        return this.getAgents[this.from] ? this.getAgents[this.from].avatar : ''

      return this.getMeta.avatar

    },
    name() {

      if (this.operator && this.getAgents)
        return this.getAgents[this.from] ? this.getAgents[this.from].nickname : ''

      return this.getMeta.name || this.getMeta.email || ''
    },
    initial() {

      if (this.operator && this.getAgents)
        return this.getAgents[this.from] ? this.getAgents[this.from].nickname.substring(0, 1) : ''

      return (this.getMeta.name || this.getMeta.email || '').substring(0, 1)
    },
    sent() {
      return moment(this.created_at).fromNow()
    },
    ...mapGetters([
      'getLang',
      'getPrimaryBg',
      'getMeta',
      'getAgent',
      'getAgents'
    ])
  },
  methods: {
    toggle() {
      this.showTail = !this.showTail
    },
    makeAliasHost (url) {
      const host = '@@UPLOADCARE_ALIAS_HOST';

      return url && url.indexOf('www.ucarecdn.com') !== -1 && host
        ? url.replace('www.ucarecdn.com', host)
        : url;
    }
  }
}
</script>
